/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Focus on search input on offcanvas open
document.querySelector('#offcanvas-search').addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#offcanvas-search input[name="q"]').focus()
})

// Handle Predictive Search
document.querySelectorAll('.predictive-search-input').forEach((input) => {
    input.addEventListener('input', window.debounce((e) => {
        const form = e.target.closest('form');
        const value = e.target.value; // Capture the search input value
        const results = form.querySelector('.predictive-search-results');
        const clearBtn = form.querySelector('.btn-clear');
        const upsells = document.querySelector('#offcanvas-search-upsell-collection-wrapper');

        if (value.length === 0) {
            results.classList.remove('show');
            clearBtn.classList.remove('show');
            upsells.classList.add('hide');
            input.setAttribute('aria-expanded', 'false');
        } else {
            const {
                textOldPrice,
                textPriceFrom,
                textViewAllResults,
                textTitleCollections,
                textTitleProducts
            } = results.dataset;

            const url = `/search/suggest.json?q=${value}&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last`;

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    const { collections, products } = data.resources.results;

                    // Filter out products with "sample" in their title, regardless of the search query
                    const filteredProducts = products.filter(product => !product.title.toLowerCase().includes("sample"));

                    let collectionListItems = '';
                    let productListItems = '';

                    collections.forEach((collection) => {
                        collectionListItems += `
                            <li class="p-2">
                                <a href="${collection.url}" class="btn btn-outline-dark btn-sm py-1">
                                    ${collection.title}
                                </a>
                            </li>
                        `;
                    });

                    filteredProducts.forEach((product) => {
                        productListItems += `
                            <li class="product-list-item py-2">
                                <a href="${product.url}" class="text-decoration-none text-dark d-block">
                                    <div class="d-flex align-items-center bg-white py-0">
                                        <img class="product-img img-fluid me-4" src="${window.resizeImage(product.featured_image.url || 'no-image.gif', '110x110', 'center')}" alt="${product.featured_image.alt}" width="110" height="110" loading="lazy">
                                        <div>
                                            <h5 class="product-title h6 small mb-2">${product.title}</h5>
                                            <div class="yotpo bottomLine mb-2" data-product-id="${product.id}"></div>
                                            <p class="product-price mb-1">
                                                <s class="product-price-compare text-secondary me-1 ${product.compare_at_price_min > product.price ? '' : 'd-none'}">
                                                    <span class="visually-hidden">${textOldPrice}</span>
                                                    ${window.formatMoney(product.compare_at_price_min)}
                                                </s>
                                                <span class="product-price-final">
                                                    <span class="product-price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">${textPriceFrom}</span>
                                                    ${window.formatMoney(product.price)}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        `;
                    });

                    results.innerHTML = `
                        <div class="predictive-search-product-list ${filteredProducts.length ? '' : 'd-none'}">
                            <h4 class="title h6 small text-uppercase mt-3 mb-3">${textTitleProducts}</h4>
                            <ul class="product-list list-unstyled mt-2 mb-4">${productListItems}</ul>
                        </div>
                        <hr class="mt-0">
                        <div class="pb-2">
                            <button type="submit" class="btn btn-sm w-100 btn-primary">${textViewAllResults}</button>
                        </div>
                    `;

                    if (window.Yotpo) {
                        const api = new Yotpo.API(yotpo);
                        api.refreshWidgets();
                    }

                    results.classList.add('show');
                    clearBtn.classList.add('show');
                    upsells.classList.add('hide');
                    input.setAttribute('aria-expanded', 'true');
                });
        }
    }, 300)); // Adjust debounce timing as needed
});

// Handle Clear button
document.querySelectorAll('#offcanvas-search .btn-clear').forEach((btn) => {
    btn.addEventListener('click', (e) => {
        btn.classList.remove('show')
        btn.closest('form').querySelector('input[name="q"]').value = ''
        btn.closest('form').querySelector('.predictive-search-results').classList.remove('show')
        document.querySelector('#offcanvas-search-upsell-collection-wrapper').classList.remove('hide')
    })
})